"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes.js");

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var partnersRoutes = ['partners', 'pricing', 'demo'];

var HomeLinks = function HomeLinks(_ref) {
  var currentPage = _ref.currentPage,
      handleAuthAction = _ref.handleAuthAction;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "mobile-main-links"
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/invite",
    onClick: function onClick() {
      (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_families_link"), 'link_press');
    },
    className: "page-link"
  }, "Funeral Invitations")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/for-homes",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_partners_link"), 'link_press'),
    className: "page-link"
  }, "For Homes")), partnersRoutes.includes(currentPage) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/pricing",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_pricing_link"), 'link_press'),
    className: "page-link"
  }, "Pricing")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/get-demo",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_demo_link"), 'link_press'),
    className: "page-link"
  }, "Demo"))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: partnersRoutes.includes(currentPage) ? 'http://learn.everdays.com/blog/' : '/blog/',
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_moments_link"), 'link_press')
  }, "Blog")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/press",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_press"), 'link_press')
  }, "Press")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/careers",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_careers"), 'link_press')
  }, "Careers")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:support@everdays.com",
    onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_contact"), 'link_press')
  }, "Contact Us")));
};

var _default = HomeLinks;
exports.default = _default;